export var pageVisibleState = function pageVisibleState(_config, data) {
  return {
    'pageVisible:state': data.pageVisibleState
  };
};